import { render } from "./CreateHouse.vue?vue&type=template&id=25c31ac6"
import script from "./CreateHouse.vue?vue&type=script&lang=js"
export * from "./CreateHouse.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__